<template>
    <ChatProactiveOfferCard
        v-if="isVisible"
        test-id="proactive-feature-offer"
        offer-label="feature"
        :header="data.action_params.card_header"
        :subtext="data.action_params.card_subtext"
        :feedback="currentFeedback"
        :saved-for-later="isSaved"
        :busy="isBusy"
        :loading="isLoading"
        :error-message="errorMessage"
        :cta-label="CTA_LABELS[data.action_params.feature] ?? 'Explore feature'"
        @dismiss="handleDismiss"
        @cta="handleOpenFeature"
        @rate="handleFeedback"
        @toggle-saved="handleToggleSaved" />
</template>

<script setup lang="ts">
import type { ParseActionsProactiveFeatureOfferAction } from "~vue/types/chat";

import ChatProactiveOfferCard from "./ChatProactiveOfferCard.vue";
import { useProactiveOfferAction } from "./useProactiveOfferAction";

const props = defineProps<{ data: ParseActionsProactiveFeatureOfferAction; lineIdx: number; messageId: number }>();
const CTA_LABELS: Record<ParseActionsProactiveFeatureOfferAction["action_params"]["feature"], string> = {
    calendar: "Connect calendar",
    my_work_insights: "Explore My Work",
    perspectives: "Take the quiz",
    collaboration_profile: "Create your profile",
    journeys: "Explore Journeys",
    microsoft_teams: "Open in Teams",
    slack: "Open in Slack",
};
const { isVisible, isLoading, isBusy, currentFeedback, isSaved, errorMessage, handleDismiss, handleOpenFeature, handleFeedback, handleToggleSaved } = useProactiveOfferAction(
    () => props.data,
    props.messageId,
    props.lineIdx,
);
</script>
